export default __webpack_public_path__ + "static/media/innovation.5ae4a22d.svg";